<template>
  <div>
    <div class="top">
      <div class="topleft">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item
            v-if="this.user.user.roles[0].id == 1"
            :to="{ path: '/home' }"
            >{{ $t("home") }}</el-breadcrumb-item
          >
          <el-breadcrumb-item>产品信息管理</el-breadcrumb-item>
          <el-breadcrumb-item>产品列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="cont">
      <div class="listbox">
        <div class="listright" v-loading="loading">
          <div class="searchleft">
            <el-form
              :inline="true"
              :model="searchform"
              class="demo-form-inline"
              @submit.native.prevent
            >
              <el-form-item label="产品名称">
                <el-input v-model="searchform.blurry" size="small"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="onSubmit">{{
                  $t("query")
                }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="searchright">
            <el-button size="small" type="primary" @click="openadd"
              >添加产品信息</el-button
            >
          </div>
          <div class="top"></div>
          <el-table
            :data="list"
            :header-cell-style="{
              background: '#f5f5f5',
              'font-weight': 'bold',
              color: '#555555',
              padding: '6px 0',
            }"
            style="width: 100%"
          >
            <el-table-column prop="productName" label="产品名称"></el-table-column>
            <el-table-column prop="logo" label="logo">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.logo"
                  style="width: 60px; height: 60px"
                  fit="contain"
                  :preview-src-list="[scope.row.logo]"
                >
                  <div slot="error" class="image-slot">
                    <span>加载失败</span>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="installment" label="是否分期">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.installment == 1" type="primary" size="mini"
                  >是</el-tag
                >
                <el-tag v-if="scope.row.installment == 0" type="info" size="mini"
                  >否</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column prop="extension" label="是否展期">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.extension == 1" type="primary" size="mini"
                  >是</el-tag
                >
                <el-tag v-if="scope.row.extension == 0" type="info" size="mini"
                  >否</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column prop="creditType" label="授信方式">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.creditType == 'dynamic'"
                  type="primary"
                  size="mini"
                  >动态</el-tag
                >
                <el-tag v-if="scope.row.creditType == 'fixed'" type="info" size="mini"
                  >固定</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column prop="mountType" label="挂载方式">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.mountType == 'link'" type="primary" size="mini"
                  >外链</el-tag
                >
                <el-tag v-if="scope.row.mountType == 'self'" type="info" size="mini"
                  >App</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column prop="productType" label="产品类型">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.productType == 1" type="primary" size="mini"
                  >主产品</el-tag
                >
                <el-tag v-if="scope.row.productType == 2" type="info" size="mini"
                  >子产品</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column prop="upProductName" label="归属产品"></el-table-column>
            <el-table-column prop="mainColor" label="主体颜色">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <div
                    :style="{
                      width: '20px',
                      height: '20px',
                      backgroundColor: scope.row.mainColor,
                      border: '1px solid #ccc',
                      marginRight: '8px',
                    }"
                  ></div>
                  <span>{{ scope.row.mainColor }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="openCount" label="打开条件（次数）"></el-table-column>
            <el-table-column prop="jobName" :label="$t('operator')" width="120">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  @click="openedit(scope.row)"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  plain
                  style="margin-right: 5px"
                ></el-button>
                <el-popconfirm
                  v-if="scope.row.productType == 2 || scope.row.mountType == 'link'"
                  :title="$t('isDel')"
                  @confirm="deleteproduct(scope.row)"
                >
                  <el-button
                    size="small"
                    type="warning"
                    icon="el-icon-delete-solid"
                    circle
                    slot="reference"
                    plain
                  ></el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <app-page
              :total="total"
              :current="pageNo"
              :pageSize="pageSize"
              @handleCurrentChange="currentchange"
              @handleSizeChange="handchange"
            ></app-page>
          </div>
        </div>
      </div>
    </div>
    <pop-up
      :title="status == 1 ? '添加产品信息' : '编辑产品信息'"
      :isshow="showadd"
      :haveconfirm="true"
      @close="getclose"
      @confirm="getconfirm"
    >
      <div slot="box">
        <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
          <el-form-item label="产品名称" prop="productName" style="width: 350px">
            <el-input v-model="form.productName" />
          </el-form-item>

          <!-- 挂载方式 -->
          <el-form-item label="挂载方式" prop="mountType" style="width: 350px">
            <el-select v-model="form.mountType" placeholder="请选择">
              <el-option label="外链" value="link"></el-option>
              <el-option label="App" value="self"></el-option>
            </el-select>
          </el-form-item>

          <!-- 包名 -->
          <el-form-item
            v-if="form.mountType == 'link'"
            label="App包名"
            prop="packageName"
            style="width: 350px"
          >
            <el-input v-model="form.packageName" />
          </el-form-item>

          <!-- 下载地址 -->
          <el-form-item
            v-if="form.mountType == 'link'"
            label="下载地址"
            prop="downUrl"
            style="width: 350px"
          >
            <el-input v-model="form.downUrl" />
          </el-form-item>

          <!-- 产品详情 -->
          <el-form-item
            v-if="form.mountType == 'link'"
            label="产品详情"
            prop="detail"
            style="width: 350px"
          >
            <el-input
              v-model="form.detail"
              type="textarea"
              :rows="5"
              placeholder="请输入产品详情（支持HTML）"
            />
          </el-form-item>

          <!-- 是否分期 -->
          <el-form-item
            v-if="form.mountType == 'self'"
            label="是否分期"
            prop="installment"
            style="width: 350px"
          >
            <el-select v-model="form.installment" placeholder="请选择">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>

          <!-- 是否展期 -->
          <el-form-item
            v-if="form.mountType == 'self'"
            label="是否展期"
            prop="extension"
            style="width: 350px"
          >
            <el-select v-model="form.extension" placeholder="请选择">
              <el-option v-if="form.installment == 0" label="是" :value="1"></el-option>
              <el-option v-if="form.installment == 1" label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>

          <!-- 授信方式 -->
          <el-form-item
            v-if="form.mountType == 'self'"
            label="授信方式"
            prop="creditType"
            style="width: 350px"
          >
            <el-select v-model="form.creditType" placeholder="请选择">
              <el-option label="动态" value="dynamic"></el-option>
              <el-option label="固定" value="fixed"></el-option>
            </el-select>
          </el-form-item>

          <!-- logo -->
          <el-form-item label="AppLogo" prop="logo" style="width: 350px">
            <el-upload
              :show-file-list="false"
              :on-success="handleLogoSuccess"
              :before-upload="beforeLogoUpload"
              :on-exceed="handleExceed"
              action="https://admin.aktivakus.com/data/api/productnew/getImageUrl"
              multiple
            >
              <template v-if="form.logo">
                <div class="logo-preview">
                  <img :src="form.logo" alt="Logo" style="width: 100px; height: 100px" />
                  <div class="logo-actions">
                    <el-button size="small" type="primary">重新上传</el-button>
                  </div>
                </div>
              </template>
              <template v-else>
                <el-button size="small" type="primary">上传Logo</el-button>
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过2MB
                </div>
              </template>
            </el-upload>
          </el-form-item>

          <!-- 产品类型 -->
          <el-form-item
            v-if="form.mountType == 'self'"
            label="产品类型"
            prop="productType"
            style="width: 350px"
          >
            <el-select v-model="form.productType" placeholder="请选择">
              <el-option label="主产品" value="1"></el-option>
              <el-option label="子产品" value="2"></el-option>
            </el-select>
          </el-form-item>

          <!-- 主体颜色 -->
          <el-form-item label="主体颜色" prop="mainColor" style="width: 350px">
            <el-color-picker v-model="form.mainColor"></el-color-picker>
          </el-form-item>

          <!-- 归属产品 -->
          <el-form-item
            v-if="form.productType == 2 || form.mountType == 'link'"
            label="归属产品"
            prop="parentProduct"
            style="width: 350px"
          >
            <el-select v-model="form.parentProduct" placeholder="请选择">
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.productName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 打开条件（次数） -->
          <el-form-item
            v-if="form.productType == 2 && form.mountType == 'self'"
            label="打开条件(次数)"
            prop="openCount"
            style="width: 350px"
          >
            <el-input-number :min="1" v-model="form.openCount" placeholder="请输入次数" />
          </el-form-item>
        </el-form>
      </div>
    </pop-up>
  </div>
</template>
<script>
import apiurl from "@/api/public";
import _api from "@/api/index";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
export default {
  components: {
    Treeselect,
  },
  data() {
    var rolesValid = (rule, value, callback) => {
      callback();
    };
    return {
      form: {
        id: null,
        productName: null,
        installment: null,
        extension: null,
        productType: null,
        creditType: null,
        logo: null,
        mountType: null,
        parentProduct: null,
        mainColor: null,
        openCount: null,
        packageName: null,
        detail: null,
        downUrl: null,
      },
      searchform: {
        blurry: "",
      },
      total: 1,
      pageNo: 1,
      pageSize: 10,
      loading: false,
      showadd: false,
      list: [],
      productList: [],
      logoUploaded: false,
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("userinfo"));
    this.getList();
    this.getproductnewAll();
  },
  methods: {
    beforeLogoUpload(file) {
      // 重置上传状态
      this.logoUploaded = false;
      // 检查文件类型
      const isImage = file.type === "image/jpeg" || file.type === "image/png";
      if (!isImage) {
        this.$message.error("只能上传 JPG/PNG 格式的图片!");
        return false;
      }
      // 检查文件大小
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },

    handleLogoSuccess(res, file) {
      // 上传成功处理
      if (res.code === 200 || res.success) {
        // 根据实际接口返回结构调整
        this.form.logo = res.data; // 获取图片地址
        this.logoUploaded = true;
        this.$message.success("Logo上传成功！");
      } else {
        this.$message.error(res.message || "上传失败，请重试");
        this.logoUploaded = false;
      }
    },
    getproductnewAll() {
      _api.get(apiurl.productnewAll, {}).then((res) => {
        this.productList = res.data;
      });
    },
    openadd() {
      this.showadd = true;
      this.status = 1;
      this.form = {
        id: null,
        productName: null,
        installment: null,
        extension: null,
        creditType: null,
        productType: null,
        logo: null,
        mountType: null,
        parentProduct: null,
        mainColor: null,
        openCount: null,
        packageName: null,
        detail: null,
        downUrl: null,
      };
    },
    openedit(row) {
      this.status = 2;
      this.form.id = row.id;
      this.form.productName = row.productName;
      this.form.installment = row.installment;
      this.form.extension = row.extension;
      this.form.creditType = row.creditType;
      this.form.productType = row.productType;
      this.form.logo = row.logo;
      this.form.mountType = row.mountType;
      this.form.parentProduct = row.parentProduct;
      this.form.mainColor = row.mainColor;
      this.form.openCount = row.openCount;
      this.form.packageName = row.packageName;
      this.form.detail = row.detail;
      this.form.downUrl = row.downUrl;
      this.showadd = true;
    },
    getclose() {
      this.$refs.form.resetFields();
      this.showadd = false;
    },
    deleteproduct(row) {
      _api
        .delete(apiurl.productnew, row.id)
        .then((res) => {
          this.$notify({
            title: this.$t("success"),
            message: this.$t("delSuccess"),
            type: "success",
          });
          this.pageNo = 1;
          this.getList();
        })
        .catch((err) => {
          this.$notify.error({
            title: this.$t("error"),
            message: err.data.message,
          });
        });
    },
    getconfirm() {
      if (this.status == 1) {
        //如果是添加
        _api
          .post(apiurl.productnew, this.form)
          .then((res) => {
            this.$notify.success({
              title: this.$t("success"),
              message: this.$t("addSuccess"),
            });
            this.pageNo = 1;
            this.getList();
            this.showadd = false;
            this.form = {
              id: null,
              productName: null,
              installment: null,
              extension: null,
              creditType: null,
              logo: null,
              productType: null,
              mountType: null,
              parentProduct: null,
              mainColor: null,
              packageName: null,
              detail: null,
              downUrl: null,
              openCount: null,
            };
          })
          .catch((err) => {
            this.$notify.error({
              title: this.$t("error"),
              message: err.data.message,
            });
          });
      } else {
        //如果是编辑
        _api
          .put(apiurl.productnew, this.form)
          .then((res) => {
            this.$notify.success({
              title: this.$t("success"),
              message: this.$t("editSuccess"),
            });
            this.pageNo = 1;
            this.getList();
            this.showadd = false;
            this.form = {
              id: null,
              productName: null,
              installment: null,
              extension: null,
              creditType: null,
              logo: null,
              packageName: null,
              detail: null,
              downUrl: null,
              mountType: null,
              productType: null,
              parentProduct: null,
              mainColor: null,
              openCount: null,
            };
          })
          .catch((err) => {
            this.$notify.error({
              title: this.$t("error"),
              message: err.data.message,
            });
          });
      }
    },
    getList() {
      this.loading = true;
      _api
        .get(apiurl.productnew, {
          page: this.pageNo,
          size: this.pageSize,
          blurry: this.searchform.blurry,
        })
        .then((res) => {
          this.loading = false;
          this.list = res.data.list;
          this.total = res.data.total;
        });
    },
    handchange(data) {
      //分页Size变化
      this.pageSize = data;
      this.pageNo = 1;
      this.getList();
    },
    currentchange(data) {
      //当前页变化
      this.pageNo = data;
      this.getList();
    },
    onSubmit() {
      this.pageNo = 1;
      this.getList();
    },
  },
};
</script>
<style scoped>
.lefttop {
  padding: 8px;
}

.listbox {
  display: flex;
}

.listleft {
  width: 20%;
  border: 1px solid #ebeef5;
}

.listright {
  width: 100%;
  margin-left: 1%;
}

.top {
  margin-top: 15px;
}

.listrighttop {
  padding: 0 10px;
  background: rgb(245, 245, 245);
  height: 40px;
  overflow: hidden;
  line-height: 40px;
  border-bottom: 1px solid #ebeef5;
}

.listrighttop strong {
  float: left;
}

.listrighttop span {
  float: right;
}

::v-deep .vue-treeselect__control,
::v-deep .vue-treeselect__placeholder,
::v-deep .vue-treeselect__single-value {
  height: 30px;
  line-height: 30px;
}
</style>
